import type { MutableToolStep } from '@toolproof-core/lib/_contract/workflow-overlay';

import { collectCaseSeedDrafts } from '@/workflow-builder/_pure/derivation/caseSeedDrafts';
import { buildPlaceholderStepKey } from '@/workflow-builder/_pure/derivation/placeholderStepKey';
import type { CaseMetadata } from '@/workflow/_contract/kernel';
import type { RuntimeState } from '@/workflow-builder/_contract/runtime';

export function deriveCaseMembership(args: {
    runtimeState: RuntimeState;
    projectedToolSteps: readonly MutableToolStep[];
}): CaseMetadata[] {
    const stepIndexByStepKey = new Map(args.projectedToolSteps.map((step, index) => [step.stepKey, index]));
    return collectCaseSeedDrafts(args.runtimeState).flatMap((draft) => {
        const whenToolStepKey = draft.whenToolStepKey ?? buildPlaceholderStepKey({
            ownerMacroStepKey: draft.ownerMacroStepKey, ownerCaseIndex: draft.ownerCaseIndex, slot: 'when',
        });
        const whatToolStepKey = draft.whatToolStepKey ?? buildPlaceholderStepKey({
            ownerMacroStepKey: draft.ownerMacroStepKey, ownerCaseIndex: draft.ownerCaseIndex, slot: 'what',
        });
        const whenStepIndex = draft.whenToolStepKey === null
            ? draft.placeholderIndexWhen
            : stepIndexByStepKey.get(whenToolStepKey);
        const whatStepIndex = draft.whatToolStepKey === null
            ? draft.placeholderIndexWhat
            : stepIndexByStepKey.get(whatToolStepKey);
        if (whenStepIndex == null || whatStepIndex == null) return [];
        return [{
            ownerMacroStepKey: draft.ownerMacroStepKey,
            ownerCaseIndex: draft.ownerCaseIndex,
            slotFamily: draft.slotFamily,
            whenToolStepKey, whatToolStepKey, whenStepIndex, whatStepIndex,
        }];
    });
}
